<template>
  <div class="inner-box" @click="goDetail(cellInfo)">
    <slot name="clickable-cell" />
  </div>
</template>

<script>
import CellMixIn from '@/mixins/cell.mixin'
export default {
  name: 'NavigationCellWrapper',
  mixins: [
    CellMixIn
  ]
}
</script>
